/**
 * Upload Schema — V2 Activities
 *
 * Maps to SchemaV2ActivityPost in bldt-ui-fn/v2Activities/schemas.ts
 * POST required: amount, currency, entity, name
 */

import { UploadSchema } from '../types';

export const v2ActivitySchema: UploadSchema = {
	entityType: 'v2Activity',
	label: 'Activities',
	apiEndpoint: '/v2/planning-activities',
	apiMethod: 'POST',
	customFieldEntityType: 'activity',
	payloadTransform: (formValues) => ({
		...formValues,
	}),
	fields: [
		{
			name: 'name',
			label: 'Activity Name',
			dataType: 'string',
			required: true,
			constraints: { minLength: 1, maxLength: 255 },
			headerAliases: ['Activity', 'Activity Title', 'Title', 'Activity Name'],
		},
		{
			name: 'amount',
			label: 'Amount',
			dataType: 'number',
			required: true,
			constraints: { min: 0 },
			headerAliases: ['Budget', 'Amount (USD)', 'Cost', 'Planned Amount'],
		},
		{
			name: 'currency',
			label: 'Currency',
			dataType: 'string',
			required: true,
			constraints: { minLength: 3, maxLength: 3 },
			defaultValue: 'USD',
			headerAliases: ['Currency Code', 'Ccy'],
		},
		{
			name: 'entity',
			label: 'Implementing Entity',
			dataType: 'relation',
			required: true,
			relation: {
				entityType: 'entity',
				matchField: 'name',
				idField: 'id',
				contextKey: 'entities',
				alternateMatchFields: ['idExternal'],
			},
			headerAliases: ['Entity', 'Implementing Agency', 'Agency', 'Organization'],
		},
		{
			name: 'workPlan',
			label: 'Work Plan',
			dataType: 'relation',
			required: false,
			relation: {
				entityType: 'workPlan',
				matchField: 'name',
				idField: 'id',
				contextKey: 'workPlans',
			},
			headerAliases: ['Work Plan Name', 'WP', 'Annual Work Plan'],
		},
		{
			name: 'componentId',
			label: 'Component',
			dataType: 'relation',
			required: false,
			relation: {
				entityType: 'component',
				matchField: 'name',
				idField: 'id',
				contextKey: 'components',
			},
			headerAliases: ['Project Component', 'Component Name'],
		},
		{
			name: 'categoryId',
			label: 'Category',
			dataType: 'relation',
			required: false,
			relation: {
				entityType: 'category',
				matchField: 'name',
				idField: 'id',
				contextKey: 'categories',
			},
			headerAliases: ['Activity Category', 'Type'],
		},
		{
			name: 'expenseTypeId',
			label: 'Expense Type',
			dataType: 'relation',
			required: false,
			relation: {
				entityType: 'expenseType',
				matchField: 'name',
				idField: 'id',
				contextKey: 'expenseTypes',
			},
			headerAliases: ['Expense Category', 'Cost Type', 'Expenditure Type'],
		},
		{
			name: 'dateStart',
			label: 'Start Date',
			dataType: 'date',
			required: false,
			headerAliases: ['Start', 'From Date', 'Begin Date', 'Planned Start'],
		},
		{
			name: 'dateEnd',
			label: 'End Date',
			dataType: 'date',
			required: false,
			headerAliases: ['End', 'To Date', 'Completion Date', 'Planned End'],
		},
		{
			name: 'description',
			label: 'Description',
			dataType: 'string',
			required: false,
			headerAliases: ['Details', 'Notes', 'Activity Description'],
		},
		{
			name: 'parentActivityId',
			label: 'Parent Activity',
			dataType: 'relation',
			required: false,
			relation: {
				entityType: 'activity',
				matchField: 'name',
				idField: 'id',
				contextKey: 'activities',
			},
			headerAliases: ['Parent', 'Parent Activity Name'],
		},
	],
};
